import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent } from "../components/ui/card";
import { api } from "../lib/api";
import { Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center cherishlink-gradient-bg p-6">
      <Card className="w-full max-w-md rounded-3xl border-border/60 soft-shadow">
        <CardContent className="p-8 md:p-10">
          <Logo />
          <h1 className="mt-6 font-display text-3xl font-bold tracking-tight">Reset password</h1>
          <p className="mt-2 text-muted-foreground">
            Enter your email and we'll send a reset link if we find an account.
          </p>

          {sent ? (
            <div className="mt-8 p-6 rounded-2xl bg-accent text-accent-foreground flex items-start gap-3" data-testid="forgot-sent-notice">
              <CheckCircle2 className="h-5 w-5 mt-0.5" />
              <div>
                <div className="font-semibold">Check your inbox</div>
                <div className="text-sm opacity-90 mt-1">
                  If an account exists for <strong>{email}</strong>, you'll receive a reset link shortly.
                </div>
              </div>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="mt-8 space-y-5">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required data-testid="forgot-email-input"
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 h-11 rounded-xl" placeholder="you@example.com" />
              </div>
              <Button type="submit" disabled={loading} className="w-full h-11 rounded-full" data-testid="forgot-submit-button">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
          )}

          <Link to="/login" className="mt-8 inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
            <ArrowLeft className="h-3.5 w-3.5" /> Back to sign in
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
